
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { completeStopFromDashboard } from '@/api';
import { Header, Job, StopCompleteParams, User } from '@/models/main';
import { notificationErrorText } from '@/utils/PortalConstants';
import KJobTimeline from '../jobTable/components/KJobTimeline/KJobTimeline.vue';
import KStatusChart from '../jobTable/components/KStatusChart/KStatusChart.vue';
import { format, utcToZonedTime } from 'date-fns-tz';
import { timeZoneDefault, statusChartLabels } from '@/utils/PortalConstants';
import { formatDateStringWithTZ } from '@/utils/InputProcessingUtilities';

@Component({
  components: {
    KStatusChart,
    KJobTimeline,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
  data() {
    return {
      statusChartLabels,
    };
  },
})
export default class JobTable extends Vue {
  @Prop({ type: Boolean, default: false }) private readonly loading: boolean | undefined;
  @Prop(Boolean) private readonly staff: boolean | undefined;
  @Prop(Boolean) private readonly showEdit: boolean | undefined;
  @Prop(Boolean) private readonly disableSort: boolean | undefined;
  @Prop(String) private readonly search: string | undefined;
  @Prop(Array) private readonly jobs: Job[] | undefined;
  @Prop(Array) private readonly headersProps: Header[];

  // to use func in the template
  private formatDateStringWithTZ = formatDateStringWithTZ;
  private user!: User;
  private today = '';

  private expanded: Job[] = [];
  private headers: Header[] = [
    { text: 'Id', value: 'id', align: 'left' },
    { text: 'Date', value: 'job_date', align: 'left' },
    { text: 'Customer Code', value: 'customer_code', align: 'left' },
    { text: 'Reference 1', value: 'ref1', align: 'left' },
    { text: 'Suburb Name', value: 'stop2_name', align: 'left' },
    { text: 'Suburb State', value: 'suburb_state2', align: 'left' },
    { text: 'Stop Name', value: 'suburb_name2', align: 'left' },
    { text: 'Service code', value: 'services', align: 'left' },
    { text: 'Driver', value: 'driver2', align: 'left' },
    { text: 'Delay', value: 'currDelay', align: 'left' },
    { text: 'Status', value: 'status', align: 'left', sortable: false },
    { text: 'Complete', value: 'complete', align: 'left', sortable: false },
  ];

  private hideNotForStaffColumns(): void {
    this.headers = this.headers.filter((h: Header) => {
      return (
        h.text !== 'Customer Code' &&
        h.text !== 'Driver' &&
        h.text !== 'Delay Time' &&
        h.text !== 'Warehouse' &&
        h.text !== 'Action'
      );
    });
  }

  // Show current driver on the table
  // Sometimes drivers could be different on different stops (ex. Split-to-Base jobs)
  private currDriver(item: Job): string {
    const driverVal = item.main_stop === 1 ? item.driver1 : item.driver2;
    return driverVal !== 'None' ? driverVal.toString() : '';
  }

  private expandRow(job: Job): void {
    if (this.expanded[0] === job) {
      this.expanded = [];
    } else {
      this.expanded = [];
      this.expanded.push(job);
    }
  }
  private rowClasses(item) {
    if (item.priority) {
      return ['rowTable', 'priority'];
    }
    if (item.is_rfc) {
      return ['rowTable', 'changeRequest'];
    }
    return ['rowTable'];
  }
  private mounted(): void {
    const userTimeZone = this.user.timezone || timeZoneDefault;
    this.today = format(utcToZonedTime(new Date(), userTimeZone), 'yyyy-MM-dd');
    if (this.headersProps) {
      this.headers = this.headersProps;
    }
    if (!this.staff) {
      this.hideNotForStaffColumns();
    }
  }
  // JOB COMPLETE
  private completeStop(item): void {
    const action = 'departed';

    const params: StopCompleteParams = {
      driver_id: item.driver2,
      job_id: item.id,
      job_date: item.job_date,
      stop_number: 2,
      pod_name: 'dashboard',
    };

    completeStopFromDashboard(action, params)
      .then(res => {
        if (res?.data.Result === 'Stop sent') {
          this.$emit('change');
        }
      })
      .then(() => {
        this.$notify({
          group: 'network',
          text: 'Job status updated',
          type: 'success',
          duration: 3000,
        });
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error updating the job status',
          text: notificationErrorText,
          type: 'warn',
        });
        return null;
      });
  }
}
